import React from 'react'
import { COLOR_TYPE_GRAY_TINT_9, ColorType } from 'src/utils/color'

import { CLASS_PREFIX } from 'src/constants'
import './infrastructure-projects-navigation-icon.scss'

type Props = {
  size?: number;
  color?: ColorType;
};

const cls = CLASS_PREFIX + 'infrastructure-projects-navigation-icon'

export const InfrastructureProjectsNavigationIcon: React.FC<Props> = ({ size = 24, color = COLOR_TYPE_GRAY_TINT_9 }) => {
  return (
    <svg
      aria-hidden={true}
      className={`${cls}__fill ${cls}__fill--${color}`}
      xmlns="http://www.w3.org/2000/svg"
      height={`${size}px`}
      viewBox="0 -960 960 960"
      width={`${size}px`}
    >
      <path d="M160-160v-640h80v640h-80Zm280 0v-160h80v160h-80Zm280 0v-640h80v640h-80ZM440-400v-160h80v160h-80Zm0-240v-160h80v160h-80Z" />
    </svg>
  )
}
